import { useQuery } from "@tanstack/react-query";
import { ErmineQueryKey } from "../../utils/reactQueryKeyUtils";
import log, { METRIC_NAME } from "../../logging";
import { sendGetTermsOfServiceCommand } from "../../utils/ermineSsrClientUtil";
import { getFormattedSdkErrorMessage } from "../../utils/errorUtils";
import { ServiceException } from "@smithy/smithy-client";

export const useGetTermsOfService = (
    portalArn: string,
    userSettingsId: string
) => {
    const { data, isLoading, error, refetch, isError } = useQuery({
        queryKey: ErmineQueryKey.GetTermsOfService(portalArn, userSettingsId),
        queryFn: async () => {
            try {
                const output = await sendGetTermsOfServiceCommand({
                    portalArn,
                });
                log.publishMetricWithDimensions(
                    METRIC_NAME.CUSTOM_BRANDING_ASSET_SUCCESS,
                    {
                        resource: "TermsOfService",
                    }
                );
                return output.termsOfService;
            } catch (err) {
                await log.error(
                    err
                        ? getFormattedSdkErrorMessage(err, "GetTermsOfService")
                        : "Failed to get terms of service"
                );
                log.publishMetricWithDimensions(
                    METRIC_NAME.MISSING_CUSTOM_BRANDING_ASSET,
                    {
                        resource: "TermsOfService",
                    }
                );
                throw err;
            }
        },
        enabled: !!portalArn && !!userSettingsId,
        staleTime: Infinity,
    });

    return {
        content: data,
        isLoading,
        error: error as ServiceException | undefined,
        refetch,
        isError,
    };
};
